/**
 * A {@code Reducer} to update the current Redux state for the known global
 * configuration. This is a stub as the configuration is set through a global.
 *
 * @param {Object} state - The current Redux state for the 'setup' feature.
 * @returns {Object}
 */
const config = (state = {}) => state;

export default config;
